var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTemplates2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.53832 5.07726C2.53832 3.31848 3.44949 2.40812 5.18069 2.40812H10.6355V2.2533C10.6355 0.977559 9.99163 0.333496 8.72815 0.333496H2.24068C0.965052 0.333496 0.333313 0.977559 0.333313 2.2533V8.76824C0.333313 10.0502 0.965052 10.688 2.24068 10.688H2.53832V5.07726ZM5.27181 13.6668H11.7593C13.0288 13.6668 13.6666 13.029 13.6666 11.7532V5.17016C13.6666 3.89442 13.0288 3.25036 11.7593 3.25036H5.27181C4.00226 3.25036 3.36444 3.89442 3.36444 5.17016V11.7532C3.36444 13.029 4.00226 13.6668 5.27181 13.6668Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTemplates2);
export default __webpack_public_path__ + "static/media/icon-templates-2.6a41ddb8a2792c5259df0cc45ad5b7cc.svg";
export { ForwardRef as ReactComponent };